export const FETCH_ACTIVITY_USER_LIST_BEGIN = "FETCH_ACTIVITY_USER_LIST_BEGIN";
export const FETCH_ACTIVITY_USER_LIST_FAILURE = "FETCH_ACTIVITY_USER_LIST_FAILURE";
export const FETCH_ACTIVITY_USER_LIST_SUCCESS = "FETCH_ACTIVITY_USER_LIST_SUCCESS";
